import { WelcomeEmptyState } from '@/features/welcome-empty-state';
import { generatePath } from '@/services/router/generate-path';
import welcomeImage from '@/assets/images/broadcasts/send-one-time-messages-to-your-audience.png';
import type { BroadcastsTab } from '../tabs';

type BroadcastsWelcomeProps = {
  workspaceId: number;
  /** The tab the reader landed on, which is where the sample-workspace link takes them. */
  tab: BroadcastsTab;
};

/** The embedded app's name for each tab, which the sample-workspace click has always reported. */
const TAB_ROUTE_NAMES = {
  one_time_sends: 'broadcasts.list.newsletters.index',
  'api-triggered': 'broadcasts.list.api-triggered.index',
} as const satisfies Record<BroadcastsTab, string>;

/** The `journeys` URL of each tab, which the embedded app serves in every workspace. */
const LEGACY_TAB_PATHS = {
  one_time_sends: '/workspaces/:workspaceId/journeys/broadcasts/one_time_sends',
  'api-triggered': '/workspaces/:workspaceId/journeys/broadcasts/api-triggered',
} as const satisfies Record<BroadcastsTab, string>;

/** What a workspace with no broadcasts of either kind sees in place of the list. */
export function BroadcastsWelcome({ workspaceId, tab }: BroadcastsWelcomeProps) {
  return (
    <WelcomeEmptyState
      label="Broadcasts"
      title="Send one-time messages to your audience"
      description="Broadcast one-time messages like newsletters, feature announcements, or pricing updates. Choose the channel and send immediately or schedule for later to maximize impact."
      actionLabel="Create broadcast"
      actionHref={generatePath('/workspaces/:workspaceId/journeys/broadcasts/new', {
        workspaceId: String(workspaceId),
      })}
      actionPermission="journeys/broadcasts/create"
      image={welcomeImage}
      sampleWorkspaceHref={(sampleWorkspaceId) =>
        generatePath(LEGACY_TAB_PATHS[tab], { workspaceId: String(sampleWorkspaceId) })
      }
      sampleWorkspaceRouteName={TAB_ROUTE_NAMES[tab]}
    />
  );
}
